import { io } from "socket.io-client";

export const createSocket = (url, options = {}) => {
  const token = localStorage.getItem("token");

  return io(url, {
    ...options,
    query: {
      token: token,
      platform: "web",
      ...(options.query || {}),
    },
  });
};
